export const buildUserUpdatePayload = (user) => Object.fromEntries([
  "name", "email", "gender", "phoneNumber", "guardianPhoneNumber", "address", "school",
  "academicLevelId", "governorate", "area", "storeId",
].map((key) => [key, key === "academicLevelId" ? Number(user[key]) : user[key]]));
